var React = require('react');

function Palette (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.5 19.6l1.3.6v-9L1.4 17c-.4 1.1.1 2.2 1.1 2.6zM15.2 4.8l5 12-7.3 3-5-11.9v-.1l7.3-3zm.1-2c-.3 0-.5 0-.8.1L7.1 6c-.7.3-1.2 1-1.2 1.8 0 .2 0 .5.1.8l5 11.9c.3.8 1 1.2 1.8 1.2.3 0 .5 0 .8-.1l7.4-3.1c1-.4 1.5-1.6 1.1-2.6L17.1 4c-.3-.8-1.1-1.2-1.8-1.2zm-4.8 7.1c-.6 0-1-.4-1-1s.4-1 1-1 1 .5 1 1-.4 1-1 1zm-4.6 9.9c0 1.1.9 2 2 2h1.4l-3.4-8.3v6.3z"}));
}

Palette.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Palette;

Palette.default = Palette;
